module.exports = __webpack_public_path__ + "assets/img/mask-bg2.990017aa.png";